import React from "react";
import Helmet from "react-helmet";
import _get from "lodash/get";
import { StaticQuery, graphql } from "gatsby";
import { url_resolve } from "../../../utils/helpers";

import ImageMeta from "./ImageMeta";
import config from "../../../utils/siteConfig";

const WebsiteMeta = ({
	data,
	settings,
	canonical,
	title,
	description,
	image,
	type,
	linkAlternate = true,
}) => {
	const settingsNode = settings?.allGhostSettings?.edges?.[0]?.node || {
		title: config.siteTitleMeta,
		description: config.siteDescriptionMeta,
		cover_image: null,
		logo: config.siteIcon,
		twitter: null
	};
	settings = settingsNode;

	const publisherLogo = url_resolve(
		config.siteUrl,
		settings.logo || config.siteIcon
	);
	let shareImage =
		image || data.feature_image || _get(settings, `cover_image`, null);

	shareImage = shareImage ? url_resolve(config.siteUrl, shareImage) : null;

	description =
		description ||
		data.meta_description ||
		data.description ||
		config.siteDescriptionMeta ||
		settings.description;
	// title = `${title || data.meta_title || data.name || data.title} - ${settings.title}`
	title = `${title || data.meta_title || data.name || data.title}`;

	return (
		<>
			<Helmet>
				<title>{title}</title>
				<meta name="description" content={description} />
				<link rel="canonical" href={canonical} />
				{linkAlternate && (
					<link rel="alternate" href={canonical} hreflang="el-gr" />
				)}

				<meta property="og:site_name" content={settings.title} />
				<meta property="og:type" content="website" />
				<meta property="og:title" content={title} />
				<meta property="og:description" content={description} />
				<meta property="og:url" content={canonical} />
				<meta name="twitter:title" content={title} />
				<meta name="twitter:description" content={description} />
				<meta name="twitter:url" content={canonical} />
				{settings.twitter && (
					<meta
						name="twitter:site"
						content={`https://twitter.com/${settings.twitter.replace(
							/^@/,
							``
						)}/`}
					/>
				)}
				{settings.twitter && (
					<meta name="twitter:creator" content={settings.twitter} />
				)}
				<script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org/",
                        "@type": "${type}",
                        "url": "${canonical}"
                        ${
													shareImage
														? `,"image": {
                                "@type": "ImageObject",
                                "url": "${shareImage}",
                                "width": "${config.shareImageWidth}",
                                "height": "${config.shareImageHeight}"
                            },`
														: `,`
												}
                        "publisher": {
                            "@type": "Organization",
                            "name": "${settings.title}",
                            "logo": {
                                "@type": "ImageObject",
                                "url": "${publisherLogo}",
                                "width": 60,
                                "height": 60
                            }
                        },
                        "mainEntityOfPage": {
                            "@type": "WebPage",
                            "@id": "${config.siteUrl}"
                        },
                        "description": "${description}"
                    }
                `}</script>
			</Helmet>
			<ImageMeta image={shareImage} />
		</>
	);
};

const WebsiteMetaQuery = (props) => (
	<StaticQuery
		query={graphql`
			query GhostSettingsWebsiteMeta {
				allGhostSettings {
					edges {
						node {
							...GhostSettingsFields
						}
					}
				}
			}
		`}
		render={(data) => <WebsiteMeta settings={data} {...props} />}
	/>
);

export default WebsiteMetaQuery;
